module.exports = __webpack_public_path__ + "img/58.ef36f57a.png";